import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { CustomConfigurationService } from '../services/custom-configuration.service';
import { catchError, map, Observable, of } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class HasCmsGuard implements CanActivate {
    constructor(private customConfigurationService: CustomConfigurationService, private router: Router) {}

    canActivate(): Observable<boolean> {
        return this.customConfigurationService.hasCMS$.pipe(
            map((hasCMS) => {
                if (hasCMS) return true;

                this.router.navigate(['/home']);
                return false;
            }),
            catchError((error) => {
                this.router.navigate(['/home']);
                return of(false);
            })
        );
    }
}
